<template>
  <section class="mt-5">
    <h2>メンバーズクラブ会員登録申込</h2>
    <div class="form-navi mb-5">
      <ul class="d-flex">
        <li class="here">申込入力</li>
        <li>内容確認</li>
        <li>送信完了</li>
      </ul>
    </div>
    <div class="form-content">
      <h3>メンバーズクラブ会員登録申込フォーム</h3>
      <p>以下の必要な項目をご入力のうえ、確認画面へ進むを押してください。</p>
      <div class="form-member my-5">
        <div class="inner">
          <form>
            <dl>
              <dt>メールアドレス</dt>
              <dd>
                <input
                  v-model="txtMailAddress"
                  ref="txtMailAddress"
                  type="email"
                  class="input-w60"
                  style="ime-mode: disabled"
                />
              </dd>
              <dt>登録申込書番号</dt>
              <dd>
                <input
                  v-model="txtSerialNo"
                  ref="txtSerialNo"
                  type="text"
                  maxlength="12"
                  class="input-w60"
                  style="ime-mode: disabled"
                /><br />
                <p>
                  「会員登録申込書兼商品注文書」の右上に記載されている番号をご入力ください。
                </p>
              </dd>
            </dl>
            <div class="border-bottom border-left border-right px-4 py-4">
              <p class="py-3">
                重要事項に同意いただける方は「同意する」にチェックを入れて確認画面へお進みください。
              </p>
              <p class="text-center"><strong>重要事項</strong></p>
              <p class="my-3">
                私は、「会員マニュアル」の内容説明を受け、当該「会員マニュアル」を受領しました。<br />クーリング・オフを含む重要事項の内容を理解し、納得の上、マナビス・スキンケア・クラブの会員になることを申し込みます。<br />また、「会員マニュアル第8項（2）の個人情報の提供」に基き、同系列の上位会員（状況によりサクセサー）に個人情報を提供することを承諾いたします。
              </p>
              <p class="text-center">
                <input
                  v-model="consent"
                  ref="consent"
                  id="consent"
                  type="checkbox"
                  class="check-02"
                />
                <label for="consent"><strong>同意する</strong></label>
              </p>
            </div>
            <div class="box-p-20 text-center mt-5">
              <button
                v-on:click="putData"
                id="btnConfirm"
                type="button"
                class="confirm-01"
              >
                確認画面へ進む
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import utl from "@/modules/Utl";
import Message from "@/modules/Message";
import Request from "@/modules/Request";
import Authenticate from "@/modules/Authenticate";

let request = new Request();
let auth = new Authenticate();

export default {
  data() {
    return {
      txtMailAddress: "",
      txtSerialNo: "",
      consent: false,
    };
  },
  mounted() {
    this.getSession();
    window.scroll(0, 0);
  },
  methods: {
    getSession() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getSession",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          console.log(data)
          if (auth.getNoLoginUid() == "") {
            console.log('setNoLoginUid')
            auth.setNoLoginUid(data.uux);
          }
          this.getData();
        });
    },
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getSerialNo",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.txtMailAddress = data.MailAddress;
          this.txtSerialNo = data.SerialNo;
        });
    },
    putData() {
      if (!this.chkMailAddress()) return;
      if (!this.chkSerialNo()) return;
      if (!this.chkConsent()) return;

      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putSerialNo",
        [this.txtMailAddress, this.txtSerialNo],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.status == "bad") {
            Message.error().fire({
              title: data.msg,
              didClose: () => {
                this.$refs.txtSerialNo.focus();
                return;
              },
            });
          } else {
            this.$router.push("/serial/confirm");
          }
        });
    },
    chkMailAddress() {
      let mes = utl.chkMustInput("メールアドレス", this.txtMailAddress);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.txtMailAddress.focus();
          },
        });
        return false;
      }
      mes = utl.chkMailAddress("メールアドレス", this.txtMailAddress);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.txtMailAddress.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkSerialNo() {
      let mes = utl.chkMustInput("登録申込書番号", this.txtSerialNo);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.txtSerialNo.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkConsent() {
      let mes =
        "重要事項に同意いただける方は「同意する」にチェックを入れてください。";
      if (!this.consent) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.consent.focus();
          },
        });
        return false;
      }
      return true;
    },
  },
};
</script>
